"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stableStringify = exports.TurnkeyActivityError = void 0;
class TurnkeyActivityError extends Error {
    constructor(input) {
        const { message, cause, activityId, activityStatus, activityType } = input;
        super(message);
        this.name = "TurnkeyActivityError";
        this.activityId = activityId ?? null;
        this.activityStatus = activityStatus ?? null;
        this.activityType = activityType ?? null;
        this.cause = cause ?? null;
    }
}
exports.TurnkeyActivityError = TurnkeyActivityError;
function stableStringify(input) {
    return JSON.stringify(input);
}
exports.stableStringify = stableStringify;
//# sourceMappingURL=shared.js.map